import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { WhatsappRequestModel } from "@model/support.model";

@Injectable({
    providedIn: "root",
})
export class SupportApiService {


    constructor(
        private http: HttpClient) {
    }
    
    sendMessage(model:WhatsappRequestModel): Observable<any> {
        return this.http.post<any>(
            '/support/SendMessage/',model
        );
    }


}
